<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0; padding: 0; box-sizing: border-box;
}
html,body,#app{
  height: 100%;
}
.el-table th{
  background-color: #F6F6F6!important; color: #666666!important;
}
.el-table td, .el-table th{
  padding: 10px 0!important;
}
.el-table{
  font-size: 12px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue